export const FETCH_SIMILAR_COMPANY_REQUEST = 'FETCH_SIMILAR_COMPANY_REQUEST'
export const FETCH_SIMILAR_COMPANY_SUCCESS = 'FETCH_SIMILAR_COMPANY_SUCCESS'
export const FETCH_SIMILAR_COMPANY_FAILED = 'FETCH_SIMILAR_COMPANY_FAILED'
